import logo from "../assets/logo.png";

function Navbar() {
return ( <header className="navbar"> <div className="logoBox">


  

    {/* NEW LOGO ADDED */}
    <img src={logo} alt="Orion Logo" className="logoImg" />

    <div>
      <h1>Orion Academy</h1>
      <p>Your Trust is Our Success</p>
    </div>
  </div>

  <nav className="navLinks">
    <a href="#home">Home</a>
    <a href="#about">About</a>
    <a href="#courses">Batches</a>
    <a href="#toppers">Toppers</a>
    <a href="#contact">Contact</a>
  </nav>

  <a href="#contact" className="joinBtn">Join Now</a>
</header>


);
}

export default Navbar;
